const windowObject = () => {
    return typeof window !== 'undefined' ? window : null;
}

const homeUrl = (project) => {
    const url = project ? `${process.env.PAGES_BASE_URL}/${project?.alias}` : 'https://www.tinaba.it';
    return url;
}

export { windowObject, homeUrl }